import React, { useState } from 'react';
import { Checkbox } from 'antd';
import { AppstoreFilled, FolderFilled, SyncOutlined, DownOutlined } from '@ant-design/icons';
import './style.scss';

const CustomMultiSelectDropdown = ({ placeholder = 'Select...', select = [], onChange = () => {}, allOption = null, options = [] }) => {
    const [isOpen, setOpen] = useState(false);
    const [selected, setSelected] = useState(select.map((item) => item.value));
    var timer;
    const handleClose = (e) => {
        timer = setTimeout(() => {
            setOpen(false);
        }, 0);
    };

    const handleOpen = (e) => {
        clearTimeout(timer);
        setOpen(true);
    };

    const handleSelChange = (option) => {
        let temp = [...selected];
        if (temp.includes(option.value)) {
            const index = temp.indexOf(option.value);
            temp.splice(index, 1);
        } else {
            temp.push(option.value);
        }
        setSelected(temp);
        onChange(temp.map((value) => options.find((item) => item.value === value)));
    };

    const renderContent = () => {
        if (selected.length === 0) return <span >{placeholder}</span>;

        let optionIcon = null,
            optionText = '';
        if (selected.length === 1) {
            optionIcon = options.find((item) => item.value === selected[0]).icon;
            optionText = options.find((item) => item.value === selected[0]).label;
        } else {
            if (allOption) optionIcon = allOption.icon;
            optionText = options
                .filter((item) => selected.includes(item.value))
                .map((item) => item.label)
                .join(', ');
        }

        if (optionIcon)
            return (
                <span>
                    {optionIcon} {optionText}
                </span>
            );
        return <span>{optionText}</span>;
    };
    return (
        <div className="custom-multiselect-wrapper" onFocus={handleOpen} onBlur={handleClose} tabIndex="100">
            <div className={`custom-multiselect-viewer ${isOpen ? 'options-open' : 'options-close'}`}>
                <div className="view-area">{renderContent()}</div>
                <DownOutlined className="dropdown-arrow" />
            </div>
            {isOpen && (
                <div className="custom-multiselect-options">
                    {allOption && (
                        <span className={`option-item${selected.length === options.length ? ' option-item-checked' : ''}`}>
                            <Checkbox
                                checked={selected.length === options.length}
                                onChange={() => {
                                    if (selected.length === options.length) {
                                        setSelected([]);
                                        onChange([]);
                                    }
                                    else {
                                        setSelected(options.map((item) => item.value));
                                        onChange(options);
                                    }
                                }}>
                                {allOption.icon} {allOption.label}
                            </Checkbox>
                        </span>
                    )}
                    {options.map((option) => (
                        <span key={option.value} className={`option-item${selected.includes(option.value) ? ' option-item-checked' : ''}`}>
                            <Checkbox
                                checked={selected.includes(option.value)}
                                onChange={() => {
                                    handleSelChange(option);
                                }}>
                                {option.icon} {option.label}
                            </Checkbox>
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomMultiSelectDropdown;
